module.exports = __webpack_public_path__ + "l.no2.d18bd436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/l.no2.jpg
// module id = fyvJ
// module chunks = 0